<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>
                  Books issued
                </h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard </router-link>\ Books issued
                </div>
              </div>
              <div class="breadcrumb-right">

                <b-dropdown size="sm" variant="link" toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon mt-4" no-caret right no-flip>
                  <template v-slot:button-content>
                    <i class="ki ki-bold-more-hor"></i>
                  </template>
                  <!--begin::Navigation-->
                  <div class="navi navi-hover min-w-md-250px">

                    <b-dropdown-text tag="div" class="navi-item">
                      <a  @click="exportIssueList()" class="navi-link">
                                <span class="navi-icon">
                                    <i class="fa fa-file-csv"></i>
                                </span>
                        <span class="navi-text"> Export</span>
                      </a>
                    </b-dropdown-text>

                  </div>
                  <!--end::Navigation-->
                </b-dropdown>
              </div>
            </div>
          </div>
          <div class="card-body">
            <issued-list></issued-list>
          </div>
          </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import IssuedList from "@/view/component/IssuedList";
import IssueService from "@/core/services/library/issue/IssueService";
const issueService = new IssueService();

export default {
  validations: {},
  name: "search-user.vue",
  components: {
    IssuedList
  },
  methods:{
    exportIssueList() {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            issueService.exportIssueList(this.search);
          }
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
